var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 551.034 551.034",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.517,
    y1: 4.5714,
    x2: 275.517,
    y2: 549.7202,
    gradientTransform: "matrix(1 0 0 -1 0 554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B7077"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#0B7077"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#0B7077"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7077"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    style: {
      fill: "url(#XMLID_2_)"
    },
    d: "M386.878,0H164.156C73.64,0,0,73.64,0,164.156v222.722 c0,90.516,73.64,164.156,164.156,164.156h222.722c90.516,0,164.156-73.64,164.156-164.156V164.156 C551.033,73.64,477.393,0,386.878,0z M495.6,386.878c0,60.045-48.677,108.722-108.722,108.722H164.156 c-60.045,0-108.722-48.677-108.722-108.722V164.156c0-60.046,48.677-108.722,108.722-108.722h222.722 c60.045,0,108.722,48.676,108.722,108.722L495.6,386.878L495.6,386.878z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.517,
    y1: 4.5714,
    x2: 275.517,
    y2: 549.7202,
    gradientTransform: "matrix(1 0 0 -1 0 554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B7077"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#0B7077"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#0B7077"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7077"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_81_",
    style: {
      fill: "url(#XMLID_3_)"
    },
    d: "M275.517,133C196.933,133,133,196.933,133,275.516 s63.933,142.517,142.517,142.517S418.034,354.1,418.034,275.516S354.101,133,275.517,133z M275.517,362.6 c-48.095,0-87.083-38.988-87.083-87.083s38.989-87.083,87.083-87.083c48.095,0,87.083,38.988,87.083,87.083 C362.6,323.611,323.611,362.6,275.517,362.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.306,
    y1: 4.5714,
    x2: 418.306,
    y2: 549.7202,
    gradientTransform: "matrix(1 0 0 -1 0 554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B7077"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#0B7077"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#0B7077"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7077"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_83_",
    style: {
      fill: "url(#XMLID_4_)"
    },
    cx: 418.306,
    cy: 134.072,
    r: 34.149
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.ba8d302dbff0671ecd1c78fc24e3717d.svg";
export { ForwardRef as ReactComponent };